import { render } from "./ConstructionItemLive.vue?vue&type=template&id=06f702c5&scoped=true"
import script from "./ConstructionItemLive.vue?vue&type=script&lang=js"
export * from "./ConstructionItemLive.vue?vue&type=script&lang=js"

import "./ConstructionItemLive.vue?vue&type=style&index=0&id=06f702c5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f702c5"]])

export default __exports__